import { ModuleWithProviders, NgModule } from '@angular/core';

import { RtUICommonModule } from '../common/common.module';
import { ColorPickerComponent } from './color-picker.component';
import { ColorPickerDirective } from './color-picker.directive';
import { ColorPickerService } from './color-picker.service';
import { SliderDirective, TextDirective } from './helpers';

@NgModule({
  imports: [RtUICommonModule],
  declarations: [ColorPickerComponent, ColorPickerDirective, TextDirective, SliderDirective],
  exports: [ColorPickerDirective],
})
export class RtUIColorPickerModule {
  public static forRoot(): ModuleWithProviders<RtUIColorPickerModule> {
    return { ngModule: RtUIColorPickerModule, providers: [ColorPickerService] };
  }
}
export { ColorPickerDirective };
